import { AbstractControl, ValidationErrors } from '@angular/forms';

// NOTE(jpr):
//  - starts with optional '+'
//  - followed by any number of numbers, parens, spaces, or hyphens
//  - ends with number
const simplifiedPhoneRegex = /^[+]?[\d() -]*\d$/;

export function PhoneValidator(control: AbstractControl): ValidationErrors | null {
  if (!control.value || simplifiedPhoneRegex.test(control.value.toString())) {
    return null;
  } else {
    return { phone: true };
  }
}
